import Marquee from "react-fast-marquee";
import { Plus } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/dholera";

export default function MarqueeStrip() {
  return (
    <div className="border-y border-border bg-background" data-testid="hero-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover className="py-3.5">
        {MARQUEE_ITEMS.map((item, i) => (
          <span
            key={i}
            className="mx-7 flex items-center gap-7 font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground"
          >
            {item}
            <Plus className="h-3 w-3 text-accent" strokeWidth={2.5} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
